/**
 * 视图：主页（home）
 * @url /home/index
 */
export default {
  /**
   * Favorite Shops 卡片
   */
  favoriteShop: {
    /**
     * 卡片标题
     */
    title: 'Favorite Shops',
    /**
     * 图标标题（卡片右上角）
     */
    echartsTitle: 'Index of last 30 days',
    /**
     * 右侧ranking的标题
     */
    ranking: 'Index Ranking ',
    /**
     * 设置按钮
     */
    setting: 'Setting',
    settingTitle: 'Setting',
    selectErrorMsg: 'Please select at least one shop',
    noShop: 'No shops in Favorites yet.',
    toAdd: 'Go to add...',
    ranking_: 'Ranking',
  },
  /**
   * Top Clicks on Jessica's Secret 卡片
   */
  topClicks: {
    /**
     * 卡片标题
     */
    title: "Top Clicks on Jessica's Secret App",
    /**
     * 分类筛选按钮名称
     */
    filter: {
      title: 'Filter',
      /**
       * 分类筛选的提示
       */
      category: 'Category',
      /**
       * 品牌筛选的提示
       */
      brand: 'Brand',
    },
    /**
     * 分类按钮
     */
    buttonGroup: {
      beauty: 'Beauty',
      bag: 'Bags',
      accessories: 'Accessories',
      other: 'Food, Liquor & Tobacco',
    },
    /**
     * 导出：筛选条件
     */
    export: {
      button: 'Download',
    },
    /**
     * 表格列
     */
    table: {
      no: 'NO.',
      image: 'Images',
      product: 'Product',
      brand: 'Brand',
      category: 'Category',
      percent: 'Percentage',
      geo: 'Geo',
      shopAmt: 'No. of Shops',
    },
  },
  /**
   * promos 卡片
   */
  promos: {
    /**
     * 卡片标题
     */
    title: 'Promos',
    /**
     * 右上角查看更多按钮
     */
    more: 'View More',
    /**
     * tabs标题
     */
    tab: {
      shop: 'Promo Shops',
      band: 'Promo Bands',
    },
    /**
     * shop tab的表格列
     */
    shopTable: {
      shops: 'Shops',
      promoAmt: 'Promo Amt',
      promoBrandsAmt: 'No. of Promo Brands',
    },
    /**
     * brand tab的表格列
     */
    bandTable: {
      brand: 'Brand',
      promoAmt: 'Promo Amt',
      promoBrandsAmt: 'Promo Shops Amt',
    },
  },
  /**
   * Jescard's  Brand Simple Index 卡片
   */
  brandSimpleIndex: {
    /**
     * 卡片标题
     */
    title: "Jessica's  Brand Index",
    /**
     * 右上角查看去分析按钮
     */
    analyze: 'Go to analyze',
    /**
     * table列
     */
    table: {
      no: 'NO.',
      logo: 'Shop Logo',
      shop: 'Shop',
      opt: 'Index（Dis-Price)',
      ret: 'Index（Ret-p)',
    },
  },
  /**
   * Jescard  Simple Index 卡片
   */
  simpleIndex: {
    /**
     * 卡片标题
     */
    title: "Jescard's Simple Index",
    /**
     * 右上角查看去分析按钮
     */
    analyze: 'Go to analyze',
    /**
     * tabs标题
     */
    tab: {
      shop: 'Shop Index',
      top: 'Top Clicks Index',
    },
    /**
     * shop tab的视图
     */
    shopTab: {
      /**
       * shop tab的表格列
       */
      table: {
        no: 'No.',
        logo: 'Shop Logo',
        name: 'Shop Name',
        opt: 'Index（Dis-Price)',
        ret: 'Index（Ret-p)',
      },
    },
    topTab: {
      /**
       * top tab的视图 搜索条件
       */
      form: {
        time: 'Time period',
        timePlaceholder: 'Select Timeframe',
        timeOptions: 'Last {0} days',
        timeRule: '事件范围为必选项',
        hotCategory: 'Category of Top clicks',
        hotCategoryPlaceholder: 'Select Timeframe',
        hotCategoryRule: 'Must Select Ranking Category',
        hotRange: 'Range of Top clicks',
        hotRangePlaceholder: 'Select Timeframe',
        hotRangeRule: 'Must Select Click Ranking',
        button: 'View',
      },
      /**
       * 表格列
       */
      table: {
        no: 'No.',
        market: 'Market',
        name: 'Shop Name',
        opt: 'Index(opt-p)',
        ret: 'Index(ret-p)',
        sku: 'SKU',
      },
    },
  },
};
